import config from '../../config';
import getMonetateParams from '../utils/monetate/getMonetateParams';

const { accountBaseUrl = '' } = config() || {};

export const skipLinks = [
  {
    name: 'Skip to main content',
    url: '#main',
  },
  {
    name: 'Skip to footer',
    url: '#footer',
  },
];

export const getTopLinks = features => {
  const { brandLinkName = '', brandLinkEvent = '' } = getMonetateParams(
    features,
    'brands-top-link'
  );

  const links = [
    {
      name: 'About us',
      url: '/customer-services/about-us',
    },
    {
      name: 'John Lewis Brands',
      url: '/content/discover-john-lewis-brands',
    },
    {
      name: 'Brands A-Z',
      url: '/brands',
    },
    {
      name: 'Our shops',
      url: '/our-shops',
    },
    {
      name: 'Customer services',
      url: '/customer-services',
    },
    {
      name: 'Our services',
      url: '/our-services',
    },
    {
      name: 'Track order',
      url: `${accountBaseUrl}/track-order`,
    },
    {
      name: 'My John Lewis',
      url: '/our-services/my-john-lewis',
    },
    {
      name: 'Partnership Credit Card',
      url:
        'https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521466AAJLPDOM10800&utm_source= www.johnlewis.com&utm_medium=referral&utm_campaign=PC0072&track=jli:JLPC0072|prenavigation|xc50',
      external: true,
    },
    {
      name: 'Insurance',
      url: 'https://www.johnlewisfinance.com/insurance.html?track=JLj0008',
      external: true,
    },
  ];

  if (brandLinkName) {
    return [
      ...links.slice(0, 3),
      {
        handler: () => {
          document.body.dispatchEvent(
            new CustomEvent('dataStateChange', {
              detail: {
                action: `${brandLinkEvent}`,
                navigation: '/brands',
              },
            })
          );
        },
        name: `${brandLinkName}`,
        url: '/brands',
      },
      ...links.slice(3),
    ];
  }

  return links;
};

export const getTopLinksWithMenu = () => {
  const links = [
    {
      name: 'Help',
      menuLinks: [
        {
          name: 'Customer Services',
          url: '/customer-services',
        },
        {
          name: 'Track Order',
          url: `${accountBaseUrl}/track-order`,
        },
        {
          name: 'Returns and Refunds',
          url: '/customer-services/returns',
        },
        {
          name: 'Delivery and Collection',
          url: '/customer-services/delivery-information',
        },
        {
          name: 'Contact Us',
          url: '/customer-services/contact-us',
        },
        {
          name: "FAQ's",
          url: '/customer-services/faq',
        },
      ],
    },
    {
      name: 'About Us',
      menuLinks: [
        {
          name: 'About us',
          url: '/customer-services/about-us',
        },
        {
          name: 'Store Finder',
          url: '/our-shops',
        },
        {
          name: 'Our Services',
          url: '/our-services',
        },
        {
          name: 'John Lewis Brands',
          url: '/content/discover-john-lewis-brands',
        },
        {
          name: 'Brands A-Z',
          url: '/brands',
        },
      ],
    },
    {
      name: 'Finance',
      menuLinks: [
        {
          name: 'Insurance',
          url: 'https://www.johnlewisfinance.com/insurance',
          external: true,
        },
        {
          name: 'Partnership Credit Card',
          url:
            'https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521466AAJLPDOM10800&utm_source= www.johnlewis.com&utm_medium=referral&utm_campaign=PC0072&track=jli:JLPC0072|prenavigation|xc50',
          external: true,
        },
        {
          name: 'Travel Money',
          url: 'https://www.johnlewisfinance.com/currency.html',
          external: true,
        },
      ],
    },
  ];

  return links;
};

export const getAccountLinks = baseUrl => [
  {
    name: 'My account',
    url: '/my-account',
  },
  {
    name: 'Online orders',
    url: `${baseUrl || ''}/orders`,
  },
  {
    name: 'My John Lewis rewards',
    url: `${baseUrl || ''}/rewards`,
  },
  {
    name: 'My reviews',
    url: `${baseUrl || ''}/my-reviews`,
  },
  {
    name: 'Wish list',
    url: `${baseUrl || ''}/wish-list`,
  },
  {
    name: 'Appointments',
    url: '/appointments/manage',
  },
  {
    name: 'Sign out',
    url: '/sign-out',
  },
];

export const getMobileLinks = baseUrl => [
  {
    name: 'My Account',
    url: '/my-account',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Sign in',
        url: '/sign-in',
        isDisplayedInGlobalNav: false,
        accountHeaderOnly: true,
      },
      {
        name: 'Track Order',
        url: `${baseUrl || ''}/track-order`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'My John Lewis rewards',
        url: `${baseUrl || ''}/rewards`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Wish List',
        url: `${baseUrl || ''}/wish-list`,
        isDisplayedInGlobalNav: false,
      },
    ],
    authenticatedItems: [
      {
        name: 'View my account',
        url: '/my-account',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Track my order',
        url: `${baseUrl || ''}/track-order`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'My John Lewis rewards',
        url: `${baseUrl || ''}/rewards`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'My reviews',
        url: `${baseUrl || ''}/my-reviews`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Wish List',
        url: `${baseUrl || ''}/wish-list`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Sign out',
        url: 'https://www.johnlewis.com/sign-out',
        isDisplayedInGlobalNav: false,
        accountHeaderOnly: true,
      },
    ],
  },
  {
    name: 'Help',
    url: '/customer-services',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Customer services',
        url: '/customer-services',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Delivery & collection',
        url: '/customer-services/delivery-information',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Returns & refunds',
        url: '/customer-services/returns',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Shop finder',
        url: '/our-shops',
        isDisplayedInGlobalNav: false,
      },
    ],
  },
  {
    name: 'Services and experiences',
    url: '/our-services',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Our services',
        url: '/our-services',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'More from us',
        url: '/our-services/more-from-john-lewis',
        isDisplayedInGlobalNav: false,
      },
    ],
  },
];

const FEEDBACK_LINK =
  'https://edigitalsurvey.com/survey/enter/s/ESV-136225211/data2/mobile/collection_url/';

export const feedbackLink = {
  name: 'Feedback',
  text: 'Your comments help us improve our website',
  button: { label: 'Leave Feedback', url: FEEDBACK_LINK },
  feedback: true,
};

export const getStaticMobileMenus = (baseUrl, signedIn) => [
  ...getMobileLinks(baseUrl).map(menu => ({
    ...menu,
    child:
      signedIn && menu.authenticatedItems
        ? menu.authenticatedItems
        : menu.child,
    authenticatedItems: undefined,
  })),
  feedbackLink,
];

export const getTabbedMobileMenus = (baseUrl, signedIn) => [
  {
    id: 0,
    name: 'My Account',
    url: '/my-account',
    child: !signedIn
      ? [
          {
            name: 'Sign in',
            url: '/sign-in',
          },
          {
            name: 'Track my order',
            url: `${baseUrl || ''}/track-order`,
          },
          {
            name: 'My John Lewis rewards',
            url: `${baseUrl || ''}/rewards`,
          },
          {
            name: 'Wish list',
            url: `${baseUrl || ''}/wish-list`,
          },
        ]
      : [
          {
            name: 'View my account',
            url: '/my-account',
          },
          {
            name: 'Track my order',
            url: `${baseUrl || ''}/track-order`,
          },
          {
            name: 'My John Lewis rewards',
            url: `${baseUrl || ''}/rewards`,
          },
          {
            name: 'Wish list',
            url: `${baseUrl || ''}/wish-list`,
          },
          {
            name: 'Sign out',
            url: 'https://www.johnlewis.com/sign-out',
          },
        ],
  },
  {
    id: 1,
    name: 'Shop',
  },
  {
    id: 2,
    name: 'Services',
    url: '/our-services',
    child: [
      {
        id: 'partership-card',
        name: 'Partnership credit card',
        url:
          'https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521466AAJLPDOM10800&utm_source=www.johnlewis.com&utm_medium=referral&utm_campaign=PC0072&track=jli:JLPC0072|prenavigation|xc50',
      },
      {
        id: 'my-john-lewis',
        name: 'My John Lewis',
        url: '/our-services/my-john-lewis',
      },
      {
        id: 'our-services',
        name: 'Services',
        url: '/our-services',
      },
      {
        id: 'insurance',
        name: 'Insurance',
        url: 'https://www.johnlewisfinance.com/insurance.html?track=JLj0008',
      },
    ],
  },
  {
    id: 3,
    name: 'Help',
    url: '/customer-services',
    child: [
      {
        id: 'customer-services',
        name: 'Customer services',
        url: '/customer-services',
      },
      {
        id: 'about-us',
        name: 'About us',
        url: '/customer-services/about-us',
      },
      {
        id: 'track-my-order',
        name: 'Track my order',
        url: `${baseUrl}/track-order`,
      },
      {
        id: 'store-finder',
        name: 'Store finder',
        url: '/our-shops',
      },
      {
        id: 'returns',
        name: 'Returns and refunds',
        url: '/customer-services/returns',
      },
      {
        id: 'delivery-and-collections',
        name: 'Delivery and collections',
        url: '/customer-services/delivery-information',
      },
    ],
  },
  {
    id: 4,
    name: 'Brands',
    url: '/brands',
    child: [
      {
        id: 'brands-az',
        name: 'Brands A-Z',
        url: '/brands',
      },
      {
        id: 'john-lewis-brands',
        name: 'John Lewis Brands',
        url: '/content/discover-john-lewis-brands',
      },
    ],
  },
];
